import Vue from 'vue'
import Vuex from 'vuex'
import campaign from './modules/campaign'
import sites from './modules/sites'
import trackingList from './modules/trackingList'
import interactions from './modules/interactions'
import modules from './modules/modules'
import spaces from './modules/spaces'
import trackingListTemplate from './modules/trackingListTemplate'

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
    modules: {
        campaign,
        sites,
        trackingList,
        interactions,
        modules,
        spaces,
        trackingListTemplate
    }
})